import React, { useState } from 'react'
// import Countdown from '../../Download/MinsCount';
import ShowMulDiv from '../../Download/ShowMulDiv'
import UserSetMulFunc from './UserSetMulFunc'
import '../../../../Style/online-train/form.css'
import Bladge from '../../Award/Bladge'
import PercentageAdd from '../../Award/PercentageAdd'
// import '../../Download/Download'
const SpeedRoundDivFunc = ({ mat, ques, row, dic, dicrange, file, min, Reminder,ch1}) => {
  const [ans, setans] = useState([])
  const [getans, getansinp] = useState()
  const [start, setStart] = useState(0)
  // const [count, setcount] = useState(0)
  // const [minutes, setMinutes] = useState(0);
  const [Merge, SetMerge] = useState("")
  const [Temp, setTemp] = useState([])
  const [last, islast] = useState(0)
  const [Shows, setShows] = useState(0);
    const [ch, setch] = React.useState("d");
  const [hidestart, sethidestart] = useState(0)
  const [index1, setindex1] = useState(true)
  const [list, setlist] = useState([])
  const [checkans, setcheckans] = useState(0)
  let dis = []
  const [count, setcount] = useState(0)
  const [currentRow, setCurrentRow] = useState(0);
  const [currentCol, setCurrentCol] = useState(0);
  const [counter, setCounter] = React.useState(0);
  const [displayedRow, setDisplayedRow] = useState([]);
  function firstcall() {
    row = 2;
    setStart(1)
    if (dic) {
      if (count < ques) {
        if (window.speechSynthesis.speaking) {
          window.speechSynthesis.cancel();
        }
        window.speechSynthesis.cancel();
        let temp;
        for (let i = 0; i < row; i++) {
          if (mat[count][i] > 0) {
            temp = mat[count][i]
            i == 1 ? dis.push("divides", temp) : dis.push(temp)

          } else {
            temp = mat[count][i]
            dis.push(temp)
          }
          temp = 0;
        }

        const voice = window.speechSynthesis.getVoices()
        const utterance = new SpeechSynthesisUtterance(dis);
        dicrange ? utterance.rate = dicrange : utterance.rate = 1
        window.speechSynthesis.speak(utterance);
        setcount(1)
        dis = []
      }
      sethidestart(true)
    } else {
      islast(true)
    }
  }
  function speak(event) {
    event.preventDefault();
    setStart(1)
    row = 2;
    if (dic) {
      if (count < ques) {
        if (window.speechSynthesis.speaking) {
          window.speechSynthesis.cancel();
        }
        window.speechSynthesis.cancel();
        let temp;
        for (let i = 0; i < row; i++) {
          if (mat[count][i] > 0) {
            temp = mat[count][i]
            // dis.push("+", temp)
            i == 1 ? dis.push("divides", temp) : dis.push(temp)
          } else {
            temp = mat[count][i]
            dis.push(temp)
          }
          temp = 0;
        }

        const voice = window.speechSynthesis.getVoices()
        const utterance = new SpeechSynthesisUtterance(dis);
        dicrange ? utterance.rate = dicrange : utterance.rate = 1
        window.speechSynthesis.speak(utterance);
        setcount(count + 1)
        dis = []
        // setans(getans)
        ans.push(getans)
        getansinp('')
      } else {
        ans.push(getans)
        getansinp('')
        islast(true)
      ch = ch1
      }
    }
  }
  React.useEffect(() => {
    setDisplayedRow(mat[currentRow]);
    // Temp.push(mat[currentRow][0]+" X "+mat[currentRow][1]);
  }, [currentRow, mat]);
  function DisplayNum() {
    list.push(mat[0][0])
    list.push(mat[0][1])
    console.log(list)
    sethidestart(true)
  }
  const DisplayNumNExt = (event) => {
    event.preventDefault()
    setindex1(false)
    if (currentRow < ques - 1) {
      ans.push(getans)
      getansinp('')
      setCurrentRow(currentRow + 1);
    } else {
      ans.push(getans)
      getansinp('')
      islast(true)
    }
  };
  const Timer = () => {
    setTimeout(() => {
      islast(true)
    }, min * 60000);
    setCounter(min * 60)
  }

  React.useEffect(() => {
    counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);
  }, [counter]);
  // let props = {
  //   min: min,
  // }
  return (
    <div className='card-show-download'>
      <div className='input-main'>
        <div className={start && dic ? 'dic-input' : "dic-hide-input"}>
          <form onSubmit={speak} className='input-form'>
            <div className={last ? "hide-final" : "input"}>
              <input type='number' value={getans} required onChange={(e) => { getansinp(e.target.value) }} id='input' />
            </div>
            <div className='in'>
              <input type='submit' className={last ? "hide-final" : "bt-purple"} value="Next" />
            </div>
          </form>
          <div className={last ? "mark-card" : "hide-final"}>
            <div className='mark-card-1'>
              <button className={Shows ? "" : "bt-purple"} onClick={() => { Shows ? setShows(0) : setShows(1) }}>{Shows ? '' : "Show"}</button>
              <div className={Shows ? "display-ans" : "hide-btn"}>
                {/* <button className='X-btn-show' onClick={() => { setShows(0) }}>X</button> */}
                <ShowMulDiv {...{ row, mat, ques, ch, ans, Reminder }} />
              </div>
            </div>
            <div className='mark-card-2'>
              <UserSetMulFunc {...{ mat, row, ans, ch, last, file, Reminder }} />
            </div>
            <PercentageAdd {...{ mat, ques, row, ans, ch1, ch,last }} />

          </div>
        </div>
        <div className={start && !dic ? 'dic-input' : "dic-hide-input"}>
          <form onSubmit={DisplayNumNExt} className='input-form'>
            <div className={last ? "hide-final" : "main-card"}>
              <div className='iner-main-card'>
                {displayedRow && displayedRow.map((item, index) => {
                  return (<h1 className='dis-ele'>{index == 1 ? <h2 className='X'> ÷ </h2> : ""}{item}</h1>);
                })}
                {index1 ? list.map((i, index) => {
                  return <h1 className='dis-ele'>{index == 1 ? <h2 className='X'> ÷ </h2> : ""}{i}</h1>
                }) : null}
              </div>
            </div>
            <div className={last ? "hide-final" : "input"}>
              <input type='number' value={getans} onChange={(e) => { getansinp(e.target.value); }} id='input' required />
            </div>

            <div className='in'>
              <input type='submit' className={last ? "hide-final" : "bt-purple btn"} value="Next" />
            </div>
          </form>
          <div className={last ? "mark-card" : "hide-final"}>
            <div className='mark-card-1'>
              <button className={Shows ? "" : "bt-purple"} onClick={() => { Shows ? setShows(0) : setShows(1) }}>{Shows ? '' : "Show"}</button>
              <div className={Shows ? "display-ans" : "hide-btn"}>
                {/* <button className='X-btn-show' onClick={() => { setShows(0) }}>X</button> */}
                <ShowMulDiv {...{ row, mat, ques, ans, Reminder, ch }} />
              </div>
            </div>
            <div className='mark-card-2'>
              <UserSetMulFunc {...{ mat, row, ans, last, file, Reminder, ch }} />
            </div>
            <PercentageAdd {...{ mat, ques, row, ans, ch1, ch,last }} />
          </div>
        </div>

      </div>
      <div className={last ? "show-bladge" : "hide-bladge"}>
        <Bladge {...{ mat, ques, row, ans, ch1,ch, last }} />
      </div>
      {counter > 1 && counter ? counter + "  Sec" : ""}
      <button className={hidestart ? "hide-btn" : "bt-purple"} onClick={() => { setStart(true); Timer(); dic ? firstcall() : DisplayNum() }}>Start ?!</button>
    </div>
  )
}
export default SpeedRoundDivFunc